<script>
const __ = wp.i18n.__;
import Shimmer from "./Shimmer.svelte";
import { fly } from 'svelte/transition';
import {onMount} from 'svelte';

export let course;
let loadingClass = "";
let showPopup = false;
let youtubeURL = "";
const regExp = /youtu(?:\.be\/|be\.com\/watch\?v=|be\.com\/embed\/)([a-zA-Z0-9_\-]+)(?:\S*)/i;

function getUrl(url) {

    var currentHost = window.location.host;

    // Replace the host in the URL with the current host
    if (url !== undefined) {
        return url.replace(/^(https?:\/\/)([^/]+)/, "$1" + currentHost);
    } else {
        return '';
    }

}

function formatYoutubeURL(url) {
    const videoID = url.match(regExp)[1];
    let imgURL = `https://img.youtube.com/vi/${videoID}/hqdefault.jpg`;
    return imgURL;
}

// if (course.loading === true) {
//   loadingClass = "animate-pulse bg-pm-grey"
// }
// console.log("length", course);
$: loadingClass = course.loading === true ? "animate-pulse bg-pm-grey" : "";

function openPopup(url) {
    showPopup = true;

    const videoID = url.match(regExp)[1];
    // console.log("urlaaaa",match[1]);
    youtubeURL = videoID;
    console.log("youtubeURL", youtubeURL);
    return youtubeURL;
}

function popuoOnClose() {
    showPopup = false;
}
let isMobile = window.innerWidth <= 768;
  // Debounce resize handler to improve performance
  let resizeTimeout;
  const handleResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      isMobile = window.innerWidth <= 768;
    }, 100); // Adjust debounce delay as needed
  };

  onMount(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });
</script>
  <svelte:window on:click={popuoOnClose} />
{#if course.loading}
<Shimmer />
{:else if course.post_type != 'video_posts'}
<div
    class="grid grid-cols-1 w-full lg:grid-cols-[370px,auto] max-w-[470px] lg:max-w-[1040px] rounded-3xl m-auto md:m-0 shadow-card overflow-hidden justify-self-center"  in:fly={{ y: -20, duration: 500 }}>
    <div class="relative">
        {#if course.featured_image_url}
        <img class="!h-[150px] md:!h-full w-full object-cover !m-0" src="{getUrl(course.featured_image_url)}" alt="image" loading="lazy" height="305" width="370" />
        {/if}
        {#if isMobile}
          {#if course.categories}
          <div class="article-video-category absolute bottom-5 left-5">
            <ul class="post-tag-list flex gap-2 flex-wrap list-none">
              {#each course.categories as cate}
              <li class="list-none"><a href={cate.url} class="p-1 !no-underline">{cate.name}</a></li>
              {/each}
            </ul>
          </div>
      {/if}
    {/if}
    </div>
    <div class="">
        <div class="flex p-5 md:p-[30px] m-auto w-full h-full flex-col justify-center">
            {#if !isMobile}
                {#if course.categories}
                    <div class="article-video-category">
                        <ul class="post-tag-list flex gap-2 flex-wrap list-none">
                        {#each course.categories as cate}
                        <li class="list-none"><a href={cate.url} class="p-1 !no-underline">{cate.name}</a></li>
                        {/each}
                        </ul>
                    </div>
                {/if}
            {/if}

            <p class="text-sm text-pm-black px-1 py-[.125rem] bg-snd-banana self-start rounded-md empty:hidden">
                {#if course.term_suggest}
                <a href="#">{course.term_suggest}</a>
                {/if}
            </p>
            {#if course.post_title}
            <h3 class="text-3.5xl font-semibold my-4">{@html course.post_title}</h3>
            {/if}
            {#if course.post_content}
            <div class="text-l text-pm-black mb-5 line-clamp-3">{@html course.post_content}</div>
            {/if}
            {#if course.start_date}
            <div class="text-l text-pm-black mb-5">
                {course.start_date} - {course.end_date}
                <!-- {course.start_date} - {course.end_date} ({course.duration} days) -->
            </div>
            {/if}
            {#if typeof course.is_online_event != "undefined"}
            <div class="text-l text-pm-black mb-5">
                {course.is_online_event ? "Online event" : "In-person event"}
            </div>
            {/if}
            <a href="{getUrl(course.url)}" class="text-left mb-5 text-pm-pink font-semibold text-2xl gtm-blog-read-more content-search-read-more-url"
                >{__("Read more", "frontend")}</a>
                {#if course.tags && course.tags.length !== 0}
                <div class="article-video-tags flex flex-row gap-2">
                  <i class="si-solid si-tags bg-gradient-to-r text-transparent bg-clip-text from-pm-yellow to-pm-darkyellow text-l mt-1"></i>
                  <ul class="tag-list-group flex gap-1 text-pm-grey flex-wrap list-none pl-0 my-0">
                    {#each course.tags as tag, i}
                      <li class="list-none">
                        <a href={tag.url} class="text-l text-pm-grey italic capitalize no-underline">{tag.name}</a>{#if i < course.tags.length - 1}, {/if}
                      </li>
                    {/each}
                  </ul>
                </div>
              {/if}
        </div>
    </div>
</div>
{:else }
<div
    class="grid grid-cols-1 lg:grid-cols-[370px,auto] max-w-[470px] lg:max-w-full rounded-3xl m-auto md:m-0 shadow-card overflow-hidden"  in:fly={{ y: -20, duration: 500 }}
    >
    <div class="relative">
        {#if course.featured_image_url}

        <img class="!h-[150px] md:!h-full w-full object-cover !m-0" src="{getUrl(course.featured_image_url)}" alt="image" loading="lazy"  height="305" width="370" />
        <a class="absolute inline-flex top-0 justify-center items-center w-full h-full z-100 cursor-pointer content-search-read-more-url" on:click|stopPropagation={openPopup(getUrl(course.post_full_content).replace(/\n/g, ''))} >

            <span class="w-[50px] h-[50px] rounded-full bg-pm-yellow/80 flex justify-center items-center">
                <i class="si-solid si-play ml-[3px] mt-[2px] text-3xl text-pm-white"></i>
            </span>
        </a>

        {:else}

        <img class="!h-[150px] md:!h-full w-full object-cover !m-0" src="{formatYoutubeURL(course.post_full_content).replace(/\n/g, '')}" alt="image" loading="lazy"  height="305" width="370" />

        <a class="absolute inline-flex top-0 justify-center items-center w-full h-full z-100 cursor-pointer" on:click|stopPropagation={openPopup(getUrl(course.post_full_content).replace(/\n/g, ''))} >

            <span class="w-[50px] h-[50px] rounded-full bg-pm-yellow/80 flex justify-center items-center">
                <i class="si-solid si-play ml-[3px] mt-[2px] text-3xl text-pm-white"></i>
            </span>
        </a>
        {/if}
        {#if showPopup}
        <div class="{showPopup ? "block" : "none"}">
            <div id="youtubePopup" class="popup {showPopup ? "!block" : "none"}">
                <!-- Close button -->
                <span class="popup-close" on:click={popuoOnClose}>&times;</span>

                <!-- YouTube embed iframe -->
                <iframe id="youtubeIframe" class="youtubeIframe" width="854" height="380" src="https://www.youtube.com/embed/{youtubeURL}" frameborder="0" data-youtube-id="{youtubeURL}" allowfullscreen></iframe>
            </div>
            <div id="overlay" class="overlay {showPopup ? "!block" : "none"}"></div></div>
        {/if}
        {#if isMobile}
        {#if course.categories}
        <div class="article-video-category absolute bottom-5 left-5">
          <ul class="post-tag-list flex gap-2 flex-wrap list-none">
            {#each course.categories as cate}
            <li class="list-none"><a href={cate.url} class="p-1 !no-underline">{cate.name}</a></li>
            {/each}
          </ul>
        </div>
    {/if}
  {/if}
    </div>
    <div class="">
        <div class="flex p-5 md:p-[30px] m-auto w-full h-full flex-col justify-center">
            {#if !isMobile}
                {#if course.categories}
                    <div class="article-video-category">
                        <ul class="post-tag-list flex gap-2 flex-wrap list-none">
                        {#each course.categories as cate}
                        <li class="list-none "><a href={cate.url} class="p-1 !no-underline">{cate.name}</a></li>
                        {/each}
                        </ul>
                    </div>
                {/if}
            {/if}
            <p
                class="text-sm text-pm-black px-1 py-[.125rem] bg-snd-banana self-start rounded-md empty:hidden"
                >
                {#if course.term_suggest}
                <a href="#">{course.term_suggest}</a>
                {/if}
            </p>
            {#if course.post_title}
            <h3 class="text-3.5xl font-semibold my-4">{@html course.post_title}</h3>
            {/if}
            <!-- {#if course.post_content}
        <div class="text-2xl text-pm-black mb-5">{@html course.post_content}</div>
            {/if} -->
            {#if course.start_date}
            <div class="text-l text-pm-black mb-5">
                {course.start_date} - {course.end_date}
                <!-- {course.start_date} - {course.end_date} ({course.duration} days) -->
            </div>
            {/if}
            {#if typeof course.is_online_event != "undefined"}
            <div class="text-l text-pm-black mb-5">
                {course.is_online_event ? "Online event" : "In-person event"}
            </div>
            {/if}
            <a class="primary-btn w-full lg:w-1/2 xl:w-1/3 py-3 px-10 text-left text-pm-pink font-semibold text-base cursor-pointer gtm-blog-read-more"  on:click|stopPropagation={openPopup(getUrl(course.post_full_content).replace(/\n/g, ''))}
                >{__("Watch video", "frontend")}</a>
            {#if course.tags && course.tags.length !== 0}
                <div class="article-video-tags flex flex-row gap-2">
                    <i class="si-solid si-tags bg-gradient-to-r text-transparent bg-clip-text from-pm-yellow to-pm-darkyellow text-l mt-1"></i>
                    <ul class="tag-list-group flex gap-1 text-pm-grey flex-wrap list-none pl-0 my-0">
                    {#each course.tags as tag, i}
                        <li class="list-none">
                        <a href={tag.url} class="text-l text-pm-grey italic capitalize no-underline">{tag.name}</a>{#if i < course.tags.length - 1}, {/if}
                        </li>
                    {/each}
                    </ul>
                </div>
            {/if}
        </div>
    </div>
</div>
{/if}

<style>
.popup {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    z-index: 9999;
    display: none;
    max-width: 90%;
    padding: 2px;
    box-sizing: content-box;
    border-radius: 20px;
}

#youtubePopup {
    width: 854px;
    height: 480px;
}

.popup iframe {
    max-width: 100%;
    border-radius: 20px;
}

#contentPopup #contentContainer {
    padding: 20px;
}

.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
    z-index: 9998;
    display: none;
}

/* Close button styles */
.popup-close {
    position: absolute;
    top: -40px;
    right: -20px;
    color: #fff;
    font-size: 45px;
    cursor: pointer;
}

@media (max-width:767px) {
    .popup-close {
        left: 50%;
        transform: translateX(-50%);
        right: auto;
        top: -65px;
    }

    .popup {
        /* max-height: 65vh;; */
    }

    #contentPopup {
        width: 100%;
        max-height: 65vh;
    }
}
</style>
